export const timeZone = 'Asia/Bangkok'
export const timeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const fullDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss'
export const displayDate = 'DD-MMM-YYYY'
export const displayDateTime = 'DD-MMM-YYYY HH:mm'


// WEBPACK FOOTER //
// ./src/lib/setting.js